import type React from 'react';

import { Typography } from '@mui/material';
import { OrdCreateInDialogButton, OrdEditInDialogButton, useIsReadonly } from '@ragu-components/ord-components';
import { ExtensionUpdateFields, PermissionFields } from '@ragu-components/ord-types';
import { RecordContextProvider, ReferenceManyField, useTranslate, WrapperField } from 'react-admin';

import { ExtensionsForm } from '../extensions/ExtensionsForm';
import { ExtensionList } from '../extensions/ExtensionsList';

import type { UserRead } from '@ragu-components/ord-types';

export const UserExtensionsTab = ({ user }: { user: UserRead }): React.ReactElement => {
  const readonly = useIsReadonly();
  const translate = useTranslate();

  const createButton = (
    <OrdCreateInDialogButton inline fullWidth>
      <ExtensionsForm defaultValues={{ user: user.id }} />
    </OrdCreateInDialogButton>
  );

  const editButton = (
    <OrdEditInDialogButton mutationMode='pessimistic' fullWidth>
      <ExtensionsForm deleteProps={{ redirect: false }} />
    </OrdEditInDialogButton>
  );

  const emptyMessage = (
    <Typography color='text.secondary' sx={{ p: 2 }}>
      {translate('ra.navigation.no_results')}
    </Typography>
  );

  return (
    <RecordContextProvider value={user}>
      <ReferenceManyField target={`${ExtensionUpdateFields.user}.id`} reference={PermissionFields.extensions}>
        <ExtensionList
          embeddedChildren={<WrapperField label={createButton}>{editButton}</WrapperField>}
          layout='embedded'
          empty={readonly ? emptyMessage : createButton}
        />
      </ReferenceManyField>
    </RecordContextProvider>
  );
};
